import React from "react";
import { useRef } from 'react';
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Component, Fragment } from "react";
import { pdf, Page, Text, View, Document, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';

import TextField from '@material-ui/core/TextField';
import AutoCompleteInput from '@material-ui/lab/Autocomplete';
import { createTheme, ThemeProvider, styled } from '@material-ui/core/styles';
import yellow from '@material-ui/core/colors/yellow';
import grey from '@material-ui/core/colors/grey';

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Progress,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
  Form,
  FormGroup,
  Label,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown,
} from 'reactstrap';

// import update from 'react-addons-update';
// import redpin from '../../../assets/images/pins/red_pin.png';
// import greenpin from '../../../assets/images/pins/green_pin.png';

// import certBG from '../../../assets/images/cert_bg.png';
// import certEdge from '../../../assets/images/cert_edge.png';
// import certEdgeRight from '../../../assets/images/cert_edge_right.png';
// import certGraphLeftEdge from '../../../assets/images/cert_graph_left_edge.png';
// import certGraphRightEdge from '../../../assets/images/cert_graph_right_edge.png';
// import certPart1 from '../../../assets/images/cert_part1.png';
// import certPart2 from '../../../assets/images/cert_part2.png';
// import certPart3 from '../../../assets/images/cert_part3.png';

import certBG from '../../../assets/images/cert_white/cert_bg.png';
import certEdge from '../../../assets/images/cert_white/cert_edge.png';
import certEdgeRight from '../../../assets/images/cert_white/cert_edge_right.png';
import certGraphLeftEdge from '../../../assets/images/cert_white/cert_graph_left_edge.png';
import certGraphRightEdge from '../../../assets/images/cert_white/cert_graph_right_edge.png';
import certPart1 from '../../../assets/images/cert_white/cert_part1.png';
import certPart2 from '../../../assets/images/cert_white/cert_part2.png';
//import certPart3 from '../../../assets/images/cert_white/cert_part3.png';
import certPart3 from '../../../assets/images/cert_white/cert_part3_evo.png';

import { Line, Bar } from 'react-chartjs-2';
import "chartjs-plugin-datalabels";
import Chart from 'react-c3-component';
import 'c3/c3.css';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';

const theme = createTheme({
	palette: {
    primary: yellow,
		type: "dark",
  },
});

var image1 = null;
var image2 = null;
var image3 = null;
var imageCount = 0;
var hasImages = false;

let lineOptions = {
	maintainAspectRatio: false,
	elements: { point: { show: true } },
	layout: {
			padding: {
				right: 6
			}
	},
	tooltips: {
		titleFontSize: 16,
		bodyFontSize: 14
	},
	scales: {
		xAxes: [{
			gridLines: {
				display: false,
				drawBorder: false,
			},
			ticks: {
				display: false
			}
		}],
		yAxes: [{
			gridLines: {
				display: false,
				drawBorder: false,
			},
			ticks: {
				display: false
			}
		}]
	},
	legend: {
		display: false,
		labels: {
			fontColor: 'rgb(255, 99, 132)'
		}
	}

}

const certStyles = StyleSheet.create({
  page: { backgroundColor: '#ffffff' },
  section: { color: 'white', textAlign: 'center', margin: 30 },
  title: {
    fontSize: 25,
    marginVertical: 2,
    textAlign: 'center',
    color: '#9c7b53',
		height: 35,
		paddingTop: 15,
		fontWeight: 1000,
  },
	dateTitle: {
    fontSize: 22,
    marginVertical: 2,
    textAlign: 'center',
    color: '#9c7b53',
		height: 30,
		fontWeight: 1000,
  },
	graphLabelTitle: {
    fontSize: 10,
    textAlign: 'center',
    color: '#9c7b53',
		height: 18,
  },
  TableCellHeaderStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 14,
    fontWeight: 900,
    backgroundColor: '#ffffff'
  },
  TableCellBodyStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 11,
    backgroundColor: '#f3c12b'
  },
  TableStyle : {
    padding: 5,
  },
  Table: {
    marginVertical: 5,
    marginHorizontal: 5,
  },
  image: {
    marginVertical: 0,
    marginHorizontal: 0,
  },
	graphLabelContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	graphLabelLeftContainer: {
		width: '51.5px',
  },
	graphLabelTitleContainer: {
		width: '169.75px',
		marginHorizontal: 0
	},
	graphLabelRightContainer: {
		width: '51.5px',
		marginRight: '1.6px'
  },
	serialContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	serialLeftContainer: {
		width: '51.5px',
  },
	serialCenterContainer: {
		width: '495px'
  },
	serialRightContainer: {
		width: '51.5px',
		marginRight: '0.75px'
  },
	edgeImage: {
		width: 51.5,
		height: 51.5
  },
	dateEdgeImage: {
		width: 51.5,
		height: 34
  },
	graphLabelEdgeImage: {
		width: 51.5,
		height: 18
  },
	graphContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	graphLeftContainer: {
		width: '43px',
		float: 'left',
		marginRight: 7
	},
	graphImageContainer: {
		width: '170px',
		marginHorizontal: 1.10,
		maxHeight: 200
	},
	graphRightContainer: {
		width: '43px',
		marginRight: '1.1px'
	},
	graphEdgeImage: {
		width: 43,
		height: 200
  },
	imageGraphOne: {
		marginVertical: 0,
    marginHorizontal: 0,
		backgroundColor: '#ff715b',
		width: '150px'
  },
	imageGraphTwo: {
		marginVertical: 0,
    marginHorizontal: 0,
		backgroundColor: '#6665dd',
		width: '150px'
  },
	imageGraphThree: {
		marginVertical: 0,
    marginHorizontal: 0,
		backgroundColor: '#33d1bf',
		width: '150px'
  },
	headerContainer: {
		textAlign: 'center',
		width: '100%',
		backgroundImage: `url('${certBG}')`,
		backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
		height: "100px"
	},
});

class GenCalibrationCert extends React.Component {

  async componentDidMount() {

    console.log("GenCalibrationCert data: " + JSON.stringify(this.props.serialNumber));
		console.log("GenCalibrationCert image1: " + JSON.stringify(this.props.chartImage1));
	}

  render() {
         return (
					 <Document>
						 <Page size="A4" style={certStyles.page}>
							 <Image style={certStyles.image} src={certPart1} />
							 <View style={certStyles.serialContainer}>
								 <View style={certStyles.serialLeftContainer}>
										<Image style={certStyles.edgeImage} src={certEdge} />
								 </View>
								 <View style={certStyles.serialCenterContainer}>
										<Text style={certStyles.title}>Serial: {this.props.serialNumber}</Text>
								 </View>
								 <View style={certStyles.serialRightContainer}>
										<Image style={certStyles.edgeImage} src={certEdgeRight} />
								 </View>
						   </View>
							 <Image style={certStyles.image} src={certPart2} />
							 <View style={certStyles.serialContainer}>
								 <View style={certStyles.serialLeftContainer}>
										<Image style={certStyles.dateEdgeImage} src={certEdge} />
								 </View>
								 <View style={certStyles.serialCenterContainer}>
										<Text style={certStyles.dateTitle}>Date: {Moment(this.props.date).format('MM/DD/YYYY')}</Text>
								 </View>
								 <View style={certStyles.serialRightContainer}>
										<Image style={certStyles.dateEdgeImage} src={certEdgeRight} />
								 </View>
						   </View>
							 <View style={certStyles.graphLabelContainer}>
								 <View style={certStyles.graphLabelLeftContainer}>
										<Image style={certStyles.graphLabelEdgeImage} src={certEdge} />
								 </View>
								 <View style={certStyles.graphLabelTitleContainer}>
										<Text style={certStyles.graphLabelTitle}>810</Text>
								 </View>
								 <View style={certStyles.graphLabelTitleContainer}>
										<Text style={certStyles.graphLabelTitle}>980</Text>
								 </View>
								 <View style={certStyles.graphLabelTitleContainer}>
										<Text style={certStyles.graphLabelTitle}>DUAL</Text>
								 </View>
								 <View style={certStyles.graphLabelRightContainer}>
										<Image style={certStyles.graphLabelEdgeImage} src={certEdgeRight} />
								 </View>
						   </View>
							 <View style={certStyles.graphContainer}>
								 <View style={certStyles.graphLeftContainer}>
										<Image style={certStyles.graphEdgeImage} src={certGraphLeftEdge} />
								 </View>
								 <View style={certStyles.graphImageContainer}>
										<Image style={certStyles.imageGraphOne} src={this.props.chartImage1} />
								 </View>
								 <View style={certStyles.graphImageContainer}>
										<Image style={certStyles.imageGraphTwo} src={this.props.chartImage2} />
								 </View>
								 <View style={certStyles.graphImageContainer}>
										<Image style={certStyles.imageGraphThree} src={this.props.chartImage3} />
								 </View>
								 <View style={certStyles.graphRightContainer}>
										<Image style={certStyles.graphEdgeImage} src={certGraphRightEdge} />
								 </View>
						   </View>
							 <Image style={certStyles.image} src={certPart3} />
						 </Page>
					 </Document>
     )}
}

class G2Calibration extends React.Component {

	intervalID = 0;

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;
		console.log('currentUser info: ' + JSON.stringify(currentUser));
		console.log('currentUser info: ' + JSON.stringify(currentUser.token));

		//this.chartRef = React.createRef();

    this.state = {
			noDevices: false,
			devicesLoaded: false,
			currentUser,
			modal: false,
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			devices: [],
			chartData: [],
			chartDateLastModified: '',
			chartData810: [],
			chartData980: [],
			chartDataDual: [],
			lineOptions1: {},
			lineOptions2: {},
			lineOptions3: {},
			hasChartData: false,
			serialNumbers: [],
			isOpen: false,
			currentDataSetting: 0,
			currentItem: "",
			csvString: "810nm - 50W Peak Calibration\r\navg,max\r\n0.8214228838347525,34.26\r\n1.7233258763611528,47.32\r\n1.7540276691654295,48.02\r\n1.784744092092303,48.66\r\n1.8095265577710757,49.42\r\n1.8239025840941965,50.13\r\n1.853086341515551,50.66\r\n1.8907252797655953,51.55\r\n1.9176661941589552,52.37\r\n1.9526977399178376,53.15\r\n1.9700319995308133,53.87\r\n2.009865983919252,54.7\r\n2.031963484877821,55.42\r\n2.0337307523618184,55.33\r\n2.051996442712922,56.01\r\n2.04928170965473,56.06\r\n2.053228310853698,55.95\r\n2.0481256748628853,55.99\r\n2.0486290812306174,55.85\r\n2.060115595372114,55.88\r\n2.0487490573622757,55.82\r\n2.0427301651858043,56.01\r\n2.053792767027211,56.0\r\n2.0577658345805054,55.98\r\n810nm - 2W Average at 50W Peak Calibration\r\navg,max\r\n2.0863575556801472,55.66\r\n2.1192786308674902,55.65\r\n2.1356967478051003,55.73\r\n2.15374605287199,55.95\r\n2.1755160222334164,55.74\r\n2.1929207608566945,55.49\r\n2.2352888569481943,55.38\r\n2.252904152041321,55.45\r\n2.2876054052654604,55.6\r\n2.3071891707764887,55.6\r\n2.3022140857183455,55.69\r\n2.3084144514358913,55.87\r\n2.318394330881313,55.91\r\n2.308271944889623,55.86\r\n2.3098026282720117,55.9\r\n2.3000325105401647,55.84\r\n2.293321125781882,55.79\r\n2.312436822497443,55.75\r\n2.3140327594024526,55.87\r\n810nm - 75W Peak Calibration\r\navg,max\r\n1.7228562023497618,47.42\r\n1.7488822705066,48.07\r\n1.771278200063471,48.64\r\n1.807661403405752,49.34\r\n1.8180038084042673,49.93\r\n1.837189073961906,50.68\r\n1.877119160920657,51.3\r\n1.9004521027470902,52.16\r\n1.9374242768796934,53.02\r\n1.9585311735156226,53.66\r\n2.0002158034776425,54.45\r\n2.027826457960127,55.12\r\n2.055815576366588,55.76\r\n2.051389672404132,55.93\r\n2.046415566710488,55.94\r\n2.031042348284061,55.85\r\n2.0439206420299083,55.94\r\n2.040910319683587,55.74\r\n2.037436895288802,55.73\r\n2.034296316874432,55.72\r\n2.0419792663738896,55.75\r\n2.0433596517931742,55.76\r\n810nm - 2W Average at 75W Peak Calibration\r\navg,max\r\n2.074367940282525,55.42\r\n2.099886383532414,55.49\r\n2.11632369095977,55.58\r\n2.1443931418284405,55.72\r\n2.171112918789419,55.68\r\n2.191517146851924,55.39\r\n2.223429507854428,55.26\r\n2.243927261816562,55.45\r\n2.28217538180647,55.56\r\n2.303124817979735,55.63\r\n2.306365507498947,55.65\r\n2.3004288823568606,55.54\r\n2.2978607861756486,55.62\r\n0.103255,0.1066\r\n2.3107805201300624,55.74\r\n2.3288429393372376,55.42\r\n2.3256057446967957,55.36\r\n2.3410947876749786,55.36\r\n2.3285626895427027,55.39\r\n2.332462819130921,55.38\r\n2.3334442732105156,55.42\r\n2.3305360054325406,55.33\r\n2.3350703077082215,55.37\r\n2.324460416486072,55.3\r\n980nm - 50W Peak Calibration\r\navg,max\r\n1.5308712360727617,41.18\r\n1.561276867412933,41.83\r\n1.571169621871489,42.3\r\n1.5791037337609641,42.7\r\n1.6005939254128303,43.1\r\n1.6096053630305807,43.51\r\n1.6321150974354068,43.98\r\n1.647257194839225,44.39\r\n1.656066871775228,44.96\r\n1.6879100095033839,45.47\r\n1.7109169476669501,46.07\r\n1.7177508179275447,46.56\r\n1.7506192304705408,47.17\r\n1.7778078013726506,47.69\r\n1.7983461427536183,48.24\r\n1.816818172282595,48.6\r\n1.8070013454128584,48.99\r\n1.8357833661981602,49.37\r\n1.8421588187217797,49.81\r\n1.8659182458723866,50.16\r\n1.8784856357748783,50.53\r\n1.9052975734915016,51.08\r\n1.926269864546537,51.65\r\n1.9406217218672623,52.28\r\n1.9737042603702486,52.85\r\n1.988798442226787,53.41\r\n2.005747400971418,53.94\r\n2.0299858678476608,54.48\r\n2.047446555008456,54.83\r\n2.059226971274812,55.21\r\n2.067208051018105,55.62\r\n2.0777250859529817,55.65\r\n2.0629941295254173,55.61\r\n2.0710036594540218,55.57\r\n2.069997432825638,55.56\r\n2.0652034020887986,55.57\r\n2.057855342838595,55.59\r\n2.06782671314248,55.56\r\n2.062369082082681,55.62\r\n2.0685058005011814,55.59\r\n980nm - 2W Average at 50W Peak Calibration\r\navg,max\r\n2.093122307625466,55.31\r\n2.1173143441519287,55.41\r\n2.13485379655525,55.5\r\n2.170380942981485,55.79\r\n2.198335855241709,55.54\r\n2.2163618600754833,55.19\r\n2.245219966812797,55.27\r\n2.267456033438562,55.33\r\n2.3060644508281194,55.55\r\n2.303930544488275,55.54\r\n2.2951469510584013,55.68\r\n0.046155,0.05933\r\n2.2543207567954466,55.78\r\n2.3491839482302472,55.08\r\n2.3455510080742563,55.06\r\n2.348428195008284,55.05\r\n2.3377752221234003,55.08\r\n2.35050004084705,55.03\r\n2.312749454211437,55.44\r\n2.3116333044286046,55.47\r\n2.3167114517060625,55.49\r\n2.317036207653636,55.49\r\n2.315159973864169,55.45\r\n2.3142304379996426,55.46\r\n2.316748090703157,55.47\r\n2.3098533014446434,55.44\r\n2.309708616252297,55.46\r\n2.313915774684054,55.47\r\n980nm - 75W Peak Calibration\r\navg,max\r\n1.5253163964814644,41.18\r\n1.5420041397486883,41.83\r\n1.5572829281204619,42.12\r\n1.5692010198162039,42.58\r\n1.593222347676335,42.97\r\n1.6096597622572235,43.43\r\n1.6269753430221094,43.85\r\n1.6470292897490986,44.27\r\n1.6657755800273273,44.86\r\n1.6855218227736795,45.39\r\n1.7060836591367543,45.96\r\n1.7192670412457203,46.5\r\n1.7483076888763511,47.04\r\n1.7671799775224015,47.56\r\n1.778245515117836,48.16\r\n1.794444532799209,48.54\r\n1.8054890978219489,48.92\r\n1.8198049088542265,49.28\r\n1.8430758799141576,49.63\r\n1.8606641618419106,50.07\r\n1.8613436116224416,50.47\r\n1.8852663811672095,51.0\r\n1.9159012889498621,51.57\r\n1.9399117006836621,52.18\r\n1.9555687358465106,52.71\r\n1.976073410049005,53.31\r\n2.007389246325804,53.88\r\n2.009851198942238,54.33\r\n2.042768049331447,54.72\r\n2.0453296152498597,55.14\r\n2.051497363676766,55.56\r\n2.052983657016791,55.51\r\n2.068839056072499,55.57\r\n2.0580954776751166,55.55\r\n2.0562939903770596,55.53\r\n2.058245454969504,55.49\r\n2.0604133417450012,55.56\r\n2.061308597585597,55.53\r\n2.052539773728209,55.54\r\n2.0651428532496063,55.53\r\n980nm - 2W Average at 75W Peak Calibration\r\navg,max\r\n2.0810282333424657,55.19\r\n2.121766448178598,55.38\r\n2.1397188863268073,55.4\r\n2.1560882351174473,55.68\r\n2.1895973782901628,55.47\r\n2.210292718995633,55.07\r\n2.2402601809576956,55.19\r\n2.2575676187337423,55.24\r\n2.2839742710073083,55.5\r\n2.3073812712395028,55.41\r\n2.3063969311556627,55.4\r\n2.3102778874044123,55.4\r\n2.321556048741513,55.44\r\n2.3189036840784154,55.44\r\n2.333558031040471,55.39\r\n2.322310011557894,55.32\r\n2.3275463482907277,55.39\r\n2.3163605552070243,55.34\r\n2.3079997000562718,55.38\r\nDual - 2W Average at 50W Peak Calibration\r\navg,max\r\n2.1139092830842516,111.1\r\n2.1778072486358266,111.8\r\n2.2153826077425047,111.0\r\n2.252585153431296,111.3\r\n2.3208583037158954,111.5\r\n2.325871393057459,111.4\r\n2.311094041393401,111.5\r\n2.316739958054891,111.4\r\n2.315641251951056,111.5\r\n2.316650135567108,111.5\r\n2.3126312362080768,111.5\r\n2.3111418893000755,111.4\r\n2.3096870247438437,111.5\r\n2.313878537690822,111.5\r\nDual - 2W Average at 75W Peak Calibration\r\navg,max\r\n2.104816280849912,111.2\r\n2.1652001473488505,111.9\r\n2.2187288187050416,110.9\r\n2.270277411217906,111.2\r\n2.260910006160991,111.1\r\n2.2626468603590943,111.2\r\n2.2401856752660367,111.1\r\n2.317707700249853,111.4\r\n2.3288235696807513,111.4\r\n2.3142717518909453,111.3\r\n2.3221737948560652,111.4\r\n2.3170653959169987,111.4\r\n2.300629118107735,111.4\r\n2.315058064065914,111.5\r\n2.3239003656068116,111.5\r\n2.3159480946452433,111.5\r\n2.318358024841666,111.5\r\nCalibration Completed\r\r\n",

	  };

		this.toggleDropDown = this.toggleDropDown.bind(this);

		this.toggle = this.toggle.bind(this);
		this.getAllSerials = this.getAllSerials.bind(this);

  }

	async componentDidMount() {

		this.setOptions();
    //this.getData();

		if (this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>0) {
			this.getAllSerials();
		} else {
			this.getData();
		}
	}

	setOptions() {

		let lineOptions1 = {
			maintainAspectRatio: false,
			legend: {
				display: false,
				labels: { fontFamily: "Nunito Sans" }
			},
			plugins: {
				datalabels: {
					display: true,
					color: "black",
					align: "end",
					anchor: "end",
					font: { size: "14", weight: "bold" }
				}
			},
			scales: {
				yAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						max: 120,
						fontFamily: "Nunito Sans",
						fontColor: '#000'
					}
				}],
				xAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						display: true,
						fontFamily: "Nunito Sans",
						fontSize: "10",
						fontColor: '#000'
					}
				}]
			},
			animation: {
		    onComplete: function(event) {
		      image1 = this.toBase64Image()
					console.log('this.image1: ' + image1);
					imageCount = imageCount+1;
					console.log('imageCount: ' + imageCount);
					if (imageCount>2) {
						hasImages = true;
						console.log('hasImages: ' + hasImages);
					}
		    }
		  }
		}

		let lineOptions2 = {
			maintainAspectRatio: false,
			legend: {
				display: false,
				labels: { fontFamily: "Nunito Sans" }
			},
			plugins: {
				datalabels: {
					display: true,
					color: "black",
					align: "end",
					anchor: "end",
					font: { size: "14", weight: "bold" }
				}
			},
			scales: {
				yAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						max: 120,
						fontFamily: "Nunito Sans",
						fontColor: '#000'
					}
				}],
				xAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						display: true,
						max: 120,
						fontFamily: "Nunito Sans",
						fontSize: "10",
						fontColor: '#000'
					}
				}]
			},
			animation: {
		    onComplete: function(event) {
		      image2 = this.toBase64Image()
					console.log('image2: ' + image2);
					imageCount = imageCount+1;
					console.log('imageCount: ' + imageCount);
					if (imageCount>2) {
						hasImages = true;
						console.log('hasImages: ' + hasImages);
					}
		    }
		  }
		}

		let lineOptions3 = {
			maintainAspectRatio: false,
			legend: {
				display: false,
				labels: { fontFamily: "Nunito Sans" }
			},
			plugins: {
				datalabels: {
					display: true,
					color: "black",
					align: "end",
					anchor: "end",
					font: { size: "14", weight: "bold" }
				}
			},
			scales: {
				yAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						fontFamily: "Nunito Sans",
						fontColor: '#000'
					}
				}],
				xAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						display: true,
						fontFamily: "Nunito Sans",
						fontSize: "10",
						fontColor: '#000'
					}
				}]
			},
			animation: {
		    onComplete: function(event) {
		      image3 = this.toBase64Image()
					console.log('image3: ' + image3);
					imageCount = imageCount+1;
					console.log('imageCount: ' + imageCount);
					if (imageCount>2) {
						hasImages = true;
						console.log('hasImages: ' + hasImages);
					}
		    }
		  }
		}

		this.setState({ lineOptions1, lineOptions2, lineOptions3 });
	}

	toggle() {
		console.log('toggle clicked');
		this.setState({
	    modal: !this.state.modal
	  });
	}

	getCertificateDocument = () => {
		return (
			<GenCalibrationCert
				serialNumber={this.state.currentItem}
				chartImage1={image1}
				chartImage2={image2}
				chartImage3={image3}
				date={this.state.chartDateLastModified}
			/>
		);
	}

	printPdfBlobInPlace = (blob, options = {}) => {
		const {
			printDelayMs = 1200
		} = options;

		const printUrl = URL.createObjectURL(blob);
		const iframe = document.createElement("iframe");

		iframe.setAttribute("aria-hidden", "true");
		iframe.style.position = "fixed";
		iframe.style.right = "0";
		iframe.style.bottom = "0";
		iframe.style.width = "1px";
		iframe.style.height = "1px";
		iframe.style.opacity = "0";
		iframe.style.pointerEvents = "none";
		iframe.style.border = "0";

		const cleanup = () => {
			if (iframe.parentNode) {
				iframe.parentNode.removeChild(iframe);
			}
			URL.revokeObjectURL(printUrl);
			window.removeEventListener("afterprint", cleanup);
		};

		iframe.onload = () => {
			window.setTimeout(() => {
				try {
					if (iframe.contentWindow) {
						iframe.contentWindow.focus();
						iframe.contentWindow.print();
						window.addEventListener("afterprint", cleanup, { once: true });
						window.setTimeout(cleanup, 60000);
						return;
					}
				} catch (error) {}

				cleanup();
				window.alert("Unable to print this calibration certificate.");
			}, printDelayMs);
		};

		iframe.src = printUrl;
		document.body.appendChild(iframe);
	};

	printCalibrationCertificate = async () => {
		try {
			const blob = await pdf(this.getCertificateDocument()).toBlob();
			this.printPdfBlobInPlace(blob, { printDelayMs: 1200 });
		} catch (error) {
			window.alert("Unable to prepare this calibration certificate for printing.");
		}
	}

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	selectDropDownItem(id, serial, uid) {

		console.log("selectDropDownItem id: " + JSON.stringify(id));
		console.log("selectDropDownItem serial: " + JSON.stringify(serial));
		console.log("selectDropDownItem uid: " + JSON.stringify(uid));

    this.setState({
      currentItem: serial,
			currentDataSetting: id
    });

		this.getCalibrationData(serial, uid);

  }

	componentWillUnmount() {
		clearInterval(this.intervalID);

	}

  getData = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"device-list";

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("all devices: " + JSON.stringify(body));

		if (body.status == 'Success') {
			if (body.response.length>0) {
				this.setState({ devices: body.response });
				this.getCalibrationData(body.response[0].SerialNumber, body.response[0].UID);
				this.setState({ currentItem: body.response[0].SerialNumber });
			}
		} else {
      //ADD ERROR MESSAGE
    }

	};

	getAllSerials = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"all-serials";

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("all evo serials: " + JSON.stringify(body));

		if (body.status == 'Success') {

			let devices = body.results;

			this.setState({ devices: body.results });

			const location = window.location;
			const query = new URLSearchParams(location.search);
			const serialNum = query.get('serial')
			console.log("serialNum: "+serialNum)//123

			if (serialNum) {
				if (serialNum.length>0) {

					let device = devices.find(o => o.SerialNumber === serialNum);
					console.log("device found: "+JSON.stringify(device));

					if (device) {
						console.log("serialNum exists get cal: "+serialNum)
						this.setState({currentItem:serialNum});
						this.getCalibrationData(serialNum, device.UID);
					} else {
						this.getCalibrationData(body.results[0].SerialNumber, body.results[0].UID);
						this.setState({ currentItem: body.results[0].SerialNumber });
					}
				}
			} else {

				var serials = body.results;

				const revisedSerials = [];
				devices.map((device, i) => {

					revisedSerials.push(String(device.SerialNumber));

				});

				this.getCalibrationData(body.results[0].SerialNumber, body.results[0].UID);
				this.setState({ currentItem: body.results[0].SerialNumber, serialNumbers: revisedSerials });
			}

		} else {
      //ADD ERROR MESSAGE
    }

	};

	getCalibrationData = async (serial, uID) => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-calibration-data?ProductID=1&SerialNumber="+serial+"&UID="+uID;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("getCalibrationData body: " + JSON.stringify(body));

		if (body.status == 'Success') {
			//this.setState({ devices: body.results });
			this.parseCSVString(body.response);
			this.setState({ hasChartData: true, chartDateLastModified: body.lastModified });

			var keyArray = body.key.split('/');

			if (keyArray.length>1) {
				var calFileName = keyArray[1];

				calFileName = calFileName.replace('.csv', '');
				calFileName = calFileName.replace('cal', '');
				console.log("calFileName: " + calFileName);

				//let calDate = Date.parse(calFileName);
				let calDate = Moment(calFileName, 'YYYYMMDDhhmmss');
				console.log("calDate: " + calDate.format('MMM Do YYYY'));
				this.setState({ chartDateLastModified: calDate });
			}

		} else {
      //ADD ERROR MESSAGE
			this.setState({ chartData: [], hasChartData: false });
    }

	}

	parseCSVString (csvString) {

		//var initialArray = this.state.csvString.split('\r\n');
		var initialArray = csvString.split('\r\n');

		console.log("initialArray: " + JSON.stringify(initialArray));

		var finalArray = [];
		var categoryArray = [];
		var averageArray = [];
		var averageHigh = 0
		var maxArray = [];
		var maxHigh = 0
		var categoryName = '';
		var categoryCount = 0;

		for (var i=0; i<initialArray.length; i++) {

			var rowArray = initialArray[i].split(',');

			if (rowArray.length>1) {
				if (initialArray[i] != 'avg,max') {

					if (rowArray[0]>averageHigh) {
						averageHigh = rowArray[0];
					}

					if (rowArray[1]>maxHigh) {
						maxHigh = rowArray[1];
					}

					averageArray.push({name: categoryName, value: rowArray[0]});
					maxArray.push({name: categoryName, value: rowArray[1]});
				}
			} else {

				if (categoryCount!=0) {

					if (averageArray.length!=0 && maxArray.length!=0 && categoryName.includes("2W Average") && !categoryName.includes("75W")) {
						var category = { name: categoryName, avgHigh: averageHigh, maxHigh: maxHigh, avgData: averageArray, maxData: maxArray };
						finalArray.push(category);
					}

				}
				//Reset categoryArray
				categoryArray = [];
				averageArray = [];
				maxArray = [];
				averageHigh = 0
				maxHigh = 0
				categoryName = rowArray[0];
				categoryCount++
			}

		}

		console.log("finalArray: " + JSON.stringify(finalArray));

		var chartData = {
					labels: finalArray.map(c => c.name),
					datasets: [{
						label: 'Average High',
						backgroundColor: '#e9c736',
						data: finalArray.map(c => c.avgHigh)
					},{
						label: 'Max High',
						backgroundColor: '#fff',
						data: finalArray.map(c => c.maxHigh)
					}]
				}

		var chartData810 = this.getBarChartData([finalArray[0]]);
		var chartData980 = this.getBarChartData([finalArray[1]]);
		var chartDataDual = this.getBarChartData([finalArray[2]]);

    this.setState({ chartData, chartData810, chartData980, chartDataDual});

		//For Future Potential Calibrartion Graphing
		this.createGraph(finalArray);

	}

	getBarChartData (data) {

		console.log("getBarChartData data: " + JSON.stringify(data));

		var chartData = {
					labels: ['Average Power in Watts', 'Peak Power in Watts'],
					datasets: [{
						label: 'Power',
						backgroundColor: '#000',
						data: [Number(data[0].avgHigh).toFixed(2), Number(data[0].maxHigh).toFixed(2)]
					}]
				}

		return chartData;
	}

	getBarChartData1 (data) {

		console.log("getBarChartData data: " + JSON.stringify(data));

		var chartData = {
					labels: data.map(c => c.name),
					datasets: [{
						label: 'Average High',
						backgroundColor: '#000',
						data: data.map(c => Number(c.avgHigh).toFixed(2))
					},{
						label: 'Max High',
						backgroundColor: '#000',
						data: data.map(c => Number(c.maxHigh).toFixed(2))
					}]
				}

		return chartData;
	}

	createGraph = (results) => {

		const graphData = {
			labels: results[0].avgData.map(c => c.name),
			datasets: [{
				label: 'Average',
				borderWidth: 0,
				backgroundColor: 'rgba(65,71,85,.6)',
				borderColor: 'rgba(65,71,85,.6)',
				pointBorderColor: 'rgba(65,71,85,.6)',
				pointBackgroundColor: 'rgba(255,199,44)',
				data: results[0].avgData.map(c => c.value),
			},
			{
				label: 'Max',
				borderWidth: 0,
				backgroundColor: 'rgba(233,236,239)',
				borderColor: 'rgba(233,236,239)',
				pointBorderColor: 'rgba(233,236,239)',
				pointBackgroundColor: 'rgba(255,199,44)',
				data: results[0].maxData.map(c => c.value),
			}]
		}

		console.log("graphData: " + JSON.stringify(graphData));
		console.log("chartData810: " + JSON.stringify(this.state.chartData810));

		this.setState({ graphData });
	}

	onChangeSerialNumber = (event) => {

		console.log("onChangeSerialNumber input id: " + event.target.id);
		console.log("onChangeSerialNumber input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		const device = this.state.devices.find(serial => serial.SerialNumber.includes(value));
		console.log("onChangeSerialNumber device: " + JSON.stringify(device));

		this.setState({ currentItem: value });

		this.selectDropDownItem(1, device.SerialNumber, device.UID);

	}

	onChangeSerialNumberAutoComplete = (event, value) => {

		console.log("onChangeSerialNumber input id: " + event.target.id);

		console.log("onChangeSerialNumber value: " + value);

		if (value != null) {

			const device = this.state.devices.find(serial => serial.SerialNumber.includes(value));
			console.log("onChangeSerialNumber device: " + JSON.stringify(device));

			this.setState({ currentItem: value });

			this.selectDropDownItem(1, device.SerialNumber, device.UID);

		}

		// let id = event.target.id;
		// let value = event.target.value;
		//
		// const device = this.state.devices.find(serial => serial.SerialNumber.includes(value));
		// console.log("onChangeSerialNumber device: " + JSON.stringify(device));
		//
		// this.setState({ currentItem: value });
		//
		// this.selectDropDownItem(1, device.SerialNumber, device.UID);

	}

	render() {

		console.log("render imageCount: " + imageCount);
		console.log("render hasImages: " + hasImages);

		return (
			<Fragment>
				<Row className="mb-3">
					<Col xs="4">
						<h1 style={{color:'#737782'}}>G2 Calibration</h1>
					</Col>
					<Col xs="12" sm="8" className="text-right">
						{this.state.currentItem!="" &&
							<Fragment>
								{this.state.hasChartData &&
									<div className="float-right" style={{ width: '175px' }}>
										<Button className="ml-3" size="md" color="dark" title="PRINT CERT" onClick={() => {this.toggle()}}>
											Download Certificate
										</Button>
									</div>
								}
								<div className="float-right" style={{ width: '175px' }}>
									{this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>0 ? (
										<ThemeProvider theme={theme}>
											<AutoCompleteInput
												value={this.state.currentItem ? this.state.currentItem : ""}
												onChange={this.onChangeSerialNumberAutoComplete}
												getItemValue={(item) => item.name}
												name="SerialNum"
												id="SerialNum"
												options={this.state.serialNumbers}
												getOptionLabel={(option) => option}
												style={{ width: '100%', color: '#b2b9bf' }}
												renderInput={(params) => <TextField {...params} />}
											/>
										</ThemeProvider>
									) : (
										<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="SerialNumber" id="SerialNumber" value={this.state.currentItem} onChange={this.onChangeSerialNumber}>
											<option value="0">Select Serial Number</option>
											{this.state.devices.map((device, key) => (
												<option value={device.SerialNumber}>{device.SerialNumber}</option>
											))}
										</Input>
									)}
								</div>
								{
									// <div className="float-right" style={{ width: '100px' }}>
									// 	<ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
									// 		<DropdownToggle color="dark" caret>
									// 			{this.state.currentItem}
									// 		</DropdownToggle>
									// 		<DropdownMenu right>
									// 			{this.state.devices.map((device, key) => {
									// 				return (
									//
									// 					<DropdownItem onClick={() => this.selectDropDownItem(key, device.SerialNumber, device.UID)}>{device.SerialNumber}</DropdownItem>
									//
									// 					);
									// 			 })}
									// 		</DropdownMenu>
									// 	</ButtonDropdown>
									// </div>
								}
								{this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>0 ? (
									<div className="float-right" style={{ width: '80px' }}>
										<h3 className="pr-2" style={{color:'#737782'}}>Serial:</h3>
									</div>
								) : (
									<div className="float-right" style={{ width: '80px' }}>
										<h3 style={{color:'#737782', lineHeight: '1.5'}}>Serial:</h3>
									</div>
								)}
							</Fragment>
						}
					</Col>
				</Row>
				{this.state.hasChartData &&
					<Row>
						<Col>
							<h4 style={{color:'#737782'}}>Date: {Moment(this.state.chartDateLastModified).format('MM/DD/YYYY')}</h4>
						</Col>
					</Row>
				}
				<Row className="mb-3">
					<Col md="12">
						<h4 style={{color:'#737782'}}>The information shown below is the actual peak and average power in watts of your Gemini EVO after factory calibration.</h4>
						<h4 style={{color:'#737782'}}>Re-calibration is recommended every 12 months in order to assure accuracy of optical power output. The Gemini EVO may be returned to the manufacturer for re-calibration, which you can arrange by contacting your distributor. Certain government or corporate entities may require calibration certificates which can also be provided by the manufacturer.</h4>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col md="12" lg="6" xl="4">
						<Card style={{ backgroundColor: "#ff715b"}} className="card-hover">
							<CardBody>
								<Row className="mb-3">
									<Col md="6">
										<h3 style={{color:'#000'}}>810 Wavelength</h3>
									</Col>
									<Col md="6" className="text-right">
										{this.state.hasChartData &&
											<h3 style={{color:'#000', lineHeight: '0.8'}}><i className="mdi mdi-verified mdi-36px" /></h3>
										}
									</Col>
								</Row>
								<Row className="mb-3">
								{this.state.hasChartData ? (
									<Fragment>
										<Col md="12">
											<Bar height={500} data={this.state.chartData810} options={this.state.lineOptions1} />
										</Col>
										{
											// <Col md="12">
											// 	<Line height={300} data={this.state.graphData} options={lineOptions} />
											// </Col>
										}
									</Fragment>
								) : (
									<Fragment>
										<Col md="12">
											<h4 className="mt-5 mb-5 p-5" style={{color:'#000', textAlign: 'center'}}>No Calibration Data for Serial: {this.state.currentItem}</h4>
										</Col>
									</Fragment>
								)}
			          </Row>
								{this.state.hasChartData &&
									<Row className="">
										<Col md="12">
											<h5 className="text-center" style={{color:'#000'}}>Power Displayed in Watts</h5>
										</Col>
									</Row>
								}
			        </CardBody>
			      </Card>
					</Col>
					<Col md="12" lg="6" xl="4">
					<Card style={{ backgroundColor: "#6665dd"}} className="card-hover">
						<CardBody>
							<Row className="mb-3">
								<Col md="6">
									<h3 style={{color:'#000'}}>980 Wavelength</h3>
								</Col>
								<Col md="6" className="text-right">
									{this.state.hasChartData &&
										<h3 style={{color:'#000', lineHeight: '0.8'}}><i className="mdi mdi-verified mdi-36px" /></h3>
									}
								</Col>
							</Row>
							<Row className="mb-3">
							{this.state.hasChartData ? (
								<Fragment>
									<Col md="12">
										<Bar height={500} data={this.state.chartData980} options={this.state.lineOptions2} />
									</Col>
								</Fragment>
							) : (
								<Fragment>
									<Col md="12">
										<h4 className="mt-5 mb-5 p-5" style={{color:'#000', textAlign: 'center'}}>No Calibration Data for Serial: {this.state.currentItem}</h4>
									</Col>
								</Fragment>
							)}
		          </Row>
							{this.state.hasChartData &&
								<Row className="">
									<Col md="12">
										<h5 className="text-center" style={{color:'#000'}}>Power Displayed in Watts</h5>
									</Col>
								</Row>
							}
		        </CardBody>
		      </Card>
					</Col>
					<Col md="12" lg="6" xl="4">
					<Card style={{ backgroundColor: "#33d1bf"}} className="card-hover">
						<CardBody>
							<Row className="mb-3">
								<Col md="6">
									<h3 style={{color:'#000'}}>DUAL Wavelength</h3>
								</Col>
								<Col md="6" className="text-right">
									{this.state.hasChartData &&
										<h3 style={{color:'#000', lineHeight: '0.8'}}><i className="mdi mdi-verified mdi-36px" /></h3>
									}
								</Col>
							</Row>
							<Row className="mb-3">
							{this.state.hasChartData ? (
								<Fragment>
									<Col md="12">
										<Bar height={500} data={this.state.chartDataDual} options={this.state.lineOptions3} />
									</Col>
								</Fragment>
							) : (
								<Fragment>
									<Col md="12">
										<h4 className="mt-5 mb-5 p-5" style={{color:'#000', textAlign: 'center'}}>No Calibration Data for Serial: {this.state.currentItem}</h4>
									</Col>
								</Fragment>
							)}
		          </Row>
							{this.state.hasChartData &&
								<Row className="">
									<Col md="12">
										<h5 className="text-center" style={{color:'#000'}}>Power Displayed in Watts</h5>
									</Col>
								</Row>
							}
		        </CardBody>
		      </Card>
					</Col>
				</Row>
				<div>
					<Modal isOpen={this.state.modal} toggle={this.toggle}>
    				<ModalHeader toggle={this.toggle}>Calibrartion Certificate</ModalHeader>
    				<ModalBody>
							<PDFViewer style={{ height: "730px", width: "100%"}}>
								{this.getCertificateDocument()}
							</PDFViewer>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle}>OK</Button>
							<Button color="primary" className="ml-1" onClick={this.printCalibrationCertificate}>Print</Button>
  					</ModalFooter>
  			  </Modal>
				</div>
			</Fragment>
		);
	}
}

export default G2Calibration;
